import { Progress } from '../../engine/design/primitives/Misc';
import type { WidgetProps } from '../../engine/fields/registry';
import { formatMinutes } from '../../lib/format';

// Field widgets the projects module registers (ModuleUI.widgets), referenced by
// FieldMeta.widget from the backend ui meta so every engine surface renders them.

/** `project-progress`: a meter + percentage for project.progress_percent. */
export function ProjectProgress({ value }: WidgetProps) {
  if (value === null || value === undefined || value === '') return <span className="hf-muted">—</span>;
  const pct = Number(value);
  return (
    <span className="hf-prj-meter" title={`${pct}% complete`}>
      <Progress value={pct / 100} tone={pct >= 100 ? 'pos' : undefined} title={`${pct}% complete`} />
      <span className="hf-num">{Math.round(pct)}%</span>
    </span>
  );
}

/** `task-effort`: estimate vs logged minutes as a meter (for project_task.actual_minutes). */
export function TaskEffort({ value, row }: WidgetProps) {
  const actual = Number(value ?? 0);
  const estimate = Number(row?.estimate_minutes ?? 0);
  const ratio = estimate > 0 ? actual / estimate : 0;
  return (
    <span className="hf-prj-meter" title={`${formatMinutes(actual)} logged of ${formatMinutes(estimate)} estimated`}>
      <Progress value={ratio} tone={ratio > 1 ? 'neg' : ratio > 0.85 ? 'warn' : undefined} title="Logged vs estimate" />
      <span className="hf-num">{formatMinutes(actual)}</span>
    </span>
  );
}
